import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  createHttpShellCommandPort,
  loadPublicModelCatalog,
  PptAgentShell,
} from "@ppt-agent/ui";
import "@ppt-agent/ui/styles.css";
import { MarketingSite } from "./marketing-site";
import "./marketing.css";
import "@ppt-agent/ui/experience.css";

const root = document.getElementById("root");
if (!root) throw new Error("Web application root was not found.");

const route = globalThis.location.pathname.replace(/\/+$/, "") || "/";
const isTrial = route === "/try";
globalThis.document.title = isTrial
  ? "创作空间 · Flowisle PPT"
  : "Flowisle PPT · 万象灵思，于此奔涌";

createRoot(root).render(
  <StrictMode>
    {isTrial ? (
      <div className="trial-surface">
        <PptAgentShell
          surface="web"
          commandPort={createHttpShellCommandPort()}
          modelCatalogLoader={loadPublicModelCatalog}
        />
      </div>
    ) : (
      <MarketingSite />
    )}
  </StrictMode>,
);
